/* Reuse the theme's product-form request, cart drawer and analytics events. */
(() => {
  customElements.whenDefined('product-form').then(() => {
    if (customElements.get('arclo-pairing-form')) return;
    const ProductForm = customElements.get('product-form');
    customElements.define('arclo-pairing-form', class extends ProductForm {
      connectedCallback() {
        if (this.form) return;
        super.connectedCallback();
        this.initiallyUnavailable = this.submitButton.disabled;
        this.form.querySelector('select[name="id"]')?.addEventListener('change', (event) => {
          const price = this.closest('.ae-pairing').querySelector('[data-pairing-price]');
          const option = event.target.selectedOptions[0];
          if (price && option) price.textContent = option.dataset.price;
        });
      }
      onSubmitHandler(event) {
        if (this.pairingBusy || this.initiallyUnavailable) {
          event.preventDefault();
          return;
        }
        return super.onSubmitHandler(event);
      }
      toggleSpinner(show) {
        super.toggleSpinner(show);
        this.pairingBusy = show;
        this.submitButton.disabled = show || this.initiallyUnavailable;
        this.submitButton.setAttribute('aria-busy', String(show));
      }
    });
  });
})();
